import img1 from './img/1.jpg'
import img2 from './img/2.jpg'
import img3 from './img/3.jpg'
import img4 from './img/4.jpg'
import img5 from './img/5.jpg'
import img6 from './img/6.jpg'
import img7 from './img/7.jpg'
import img8 from './img/8.jpg'
import img9 from './img/9.jpg'
import img10 from './img/10.jpg'
import img11 from './img/11.JPG'
import img12 from './img/12.jpg'
import img13 from './img/13.jpg'
import img14 from './img/14.jpg'
import img15 from './img/15.jpg'
import img16 from './img/16.jpg'
import img17 from './img/17.jpg'
import img18 from './img/18.jpg'
import img19 from './img/19.jpg'
import img20 from './img/20.jpg'
import img21 from './img/21.jpg'
import img22 from './img/22.jpg'
import img23 from './img/23.jpg'
import img24 from './img/24.jpg'
import img25 from './img/25.jpg'

export const photoData = [
  {
    img: img1,
    title: 'Ela que quase não adora uma arte',
    text: <>
      A cara de arteira não é só cara! Adora roles aleatórios e atazanar os outros.
      Ritmo gostoso de aproveitar o que é bom da vida sem se preocupar com os outros.
      Ideal para taekwondozistas e judóquistas.
    </>,
  },
  {
    img: img2,
    title: 'Ela que não tem um olhar assassino',
    text: <>
      Vem cá...
      Vem...
      Deixa eu te contar uma coisinha...
    </>,  
  },
  {
    img: img4,
    title: 'Ela que é super criativa',
    text: <>
      Bora montar máscaras de carnaval?
      Bora num parque de cama elástica?
      Bora para uma cabana aleatória no meio do nada?
      Bora pra um resort?
      Bora no parque de diversão?
      Bora andar bebendo por aí?
      Tem algum passeio com voce que é ruim?
    </>, 
  },
  {
    img: img5,
    title: 'Ela que proporciona os melhores momentos',
    text: <>
      Sou muito feliz com sua companhia.
      Sou muito feliz com nossa sincronia.
      Sou muito feliz com nossas conversas.
      Sou muito feliz com a nossa química.
      Sou muito feliz com nossas risadas.
      Sou muito feliz com nossos momentos de silêncio.
      Sou muito feliz com nossos momentos de diversão.
      Sou muito feliz com nossos momentos de carinho.
      Sou muito feliz com nós.
    </>,   
  },
  {
    img: img6,
    title: 'Ela que adora pegar tétano',
    text: <>
      Bora no parque de diversão nesses brinquedos caindo aos pedaços pegar tétano e depois ir na balada?
      - BORA
    </>,   
  },
  {
    img: img7,
    title: 'Ela que quase não gosta de dormir',
    text: <>
      Gosta de dormir mais que 3 pessoas normais juntas? - Sim
      Anda tão lento que parece estar se arrastando? - Também
      Mas quem disse que a vida precisa ser vivida correndo?
      Gosto muito do jeito que leva a vida. Sem pressa, aproveitando os detalhes e vivendo os momentos do seu jeito.
    </>,  
  },
  {
    img: img3,
    title: 'Ela que nem se perde na própria idade',
    text: <>
      Nós temos 3 anos de diferença né?
      - Não, nós temos 4.
      Mas esse ano eu faço 35...
      - Então Stell...
    </>,    
  },
  {
    img: img9,
    title: 'Ela que quase não gosta do caos',
    text: <>
      Bora beber sem comer nada porque é assim que eu gosto do caos.
      MUAHAHAHAHA
    </>,     
  },
  {
    img: img10,
    title: 'Ela que quase não gosta de usar da criatividade',
    text: <>
      Máquiagem, desenho, pintura...
      A maneira que repara no detalhe coisas
      O cuidado que tem com o que faz, independe pra que seja
      Não tem ideia do quanto isso me encanta.
    </>,    
  },
  {
    img: img8,
    title: 'Ela que quase não gosta de fazer pose',
    text: <>
      Ela que é a viciada dos boomerangs e adora fotinhos com pose.
    </>,   
  },
  {
    img: img11,
    title: 'Ela que é muito radical',
    text: <>
      Desde parques de diversões até skydiving indoor. Porque não?
    </>,   
  },
  {
    img: img12,
    title: 'Ela que é minha parceira sempre',
    text: <>
      Desde as maiores aventuras até ficar no sofá sem fazer nada.
      O importante de verdade é estar com você, independente de onde.
    </>,   
  },
  {
    img: img13,
    title: 'Ela que está nas minhas melhores fotos',
    text: <>
      Só trazendo mais charme para as fotos. Como pode?
    </>,   
  },
  {
    img: img14,
    title: 'Ela que torna tudo mais colorido',
    text: <>
      Com você a vida não tem filtros...
      A realidade é muito melhor, mais leve e muito mais bonita.
    </>,   
  },
  {
    img: img15,
    title: 'Não tem tempo ruim',
    text: <>
      Faça calor, faça frio, ou faça salame de javali. É sempre melhor contigo.
    </>,   
  },
  {
    img: img16,
    title: 'Nhact',
    text: <>
      Só nhact mesmo
    </>,   
  },
  {
    img: img17,
    title: 'Ela que tem o sorriso mais lindo',
    text: <>
      Eu poderia facilmente passar horas só te olhando sorrir.
      E é o sorriso que eu quero ver todos os dias.
    </>,   
  },
  {
    img: img18,
    title: 'Que tetéia boa sô!',
    text: <>
      Ficar horas desenhando corações em uma camisa rosa só para eu combinar com ela? SIM!
    </>,   
  },
  {
    img: img19,
    title: 'Atiradora, Pistoleira e Flecheira',
    text: <>
      Não imaginava que a flechada do cupido seria tão... literal.
    </>,   
  },
  {
    img: img20,
    title: 'NO HABLO INGLES',
    text: <>
      
    </>,   
  },
  {
    img: img21,
    title: 'RISOS HISTÉRICOS',
    text: <>
      E quem diria que o riso histérico mais gostoso seria na porra do VELOCICOSTER
    </>,   
  },
  {
    img: img22,
    title: 'Bunny',
    text: <>
      
    </>,   
  },
  {
    img: img23,
    title: 'Galãs',
    text: <>
      Não tem como ficar feio numa foto com essa maravilhosa.
    </>,   
  },
  {
    img: img24,
    title: 'Ela que tem os melhores momentos',
    text: <>
      Aqueles instantes únicos que a gente guarda para sempre.
      Cada momento com você é uma nova aventura.
    </>,   
  },
  {
    img: img25,
    title: 'Ela que me faz querer viver mais',
    text: <>
      É com você que eu quero conhecer os lugares do mundo, e me perder na vastidão do espaço.
    </>,   
  }
];
